export const VIEWS = {
  LIST: 'list',
  MONTH: 'dayGridMonth',
  WEEK: 'timeGridWeek',
  DAY: 'timeGridDay',
} as const;

export const BUTTONS_VIEWS = [
  {
    label: 'List',
    id: VIEWS.LIST,
  },
  {
    label: 'Month',
    id: VIEWS.MONTH,
  },

  {
    label: 'Week',
    id: VIEWS.WEEK,
  },
  {
    label: 'Day',
    id: VIEWS.DAY,
  },
] as const;

export const EVENTS_FILTERS = {
  ALL: 'all',
  BOOKED: 'booked',
  CUSTOMERS: 'customers',
} as const;
